import {
  Connection,
  ConnectionStatus,
  objectIdSchema,
  paginationWithSearchSchema,
} from '@hero/schema';
import { z } from 'zod';
import { API } from '..';

/**
 * `Connection` collection — bilateral relationship between two parties.
 * See `docs/relations-v2/02-data-model.md` section 6 for the full
 * schema; only the read + lifecycle endpoints live here (writes go
 * through commercial actions: Order accept, Offer accept, Agreement
 * create, Route create).
 */

//* get all — "My Network" page
export const connectionGetAllAPISchema = paginationWithSearchSchema.extend({
  /** Optional: filter by lifecycle status. */
  status: z.enum(['pending', 'accepted', 'blocked'] as [
    ConnectionStatus,
    ...ConnectionStatus[],
  ]).optional(),
});
export type ConnectionGetAllAPI = API<
  z.infer<typeof connectionGetAllAPISchema>,
  Connection[]
>;

//* get one
export const connectionGetOneAPISchema = z.object({
  _id: objectIdSchema,
});
export type ConnectionGetOneAPI = API<
  z.infer<typeof connectionGetOneAPISchema>,
  Connection
>;

//* accept — flip pending → accepted
export const connectionAcceptAPISchema = z.object({
  _id: objectIdSchema,
});
export type ConnectionAcceptAPI = API<
  z.infer<typeof connectionAcceptAPISchema>,
  Connection
>;

//* block
export const connectionBlockAPISchema = z.object({
  _id: objectIdSchema,
});
export type ConnectionBlockAPI = API<
  z.infer<typeof connectionBlockAPISchema>,
  Connection
>;
